import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const path = '../oldPages/insert-management/approve/index.html';

const links: Record<string, string> = {
  home: '/infoTrac/insert-management',
  submit: '/infoTrac/insert-management?act=approve',
};

function InsertManagementApprove() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleIframeLoad = () => {
      const iframeDocument = iframeRef.current?.contentDocument || iframeRef.current?.contentWindow?.document;

      if (!iframeDocument) return;

      const home = iframeDocument.getElementsByClassName('home');
      const submit = iframeDocument.getElementById('saveBtn');

      if (submit) {
        submit.addEventListener('click', () => navigate(links.submit));
      }

      if (home.length) {
        for (let i = 0; i < home.length; i++) {
          home[i].addEventListener('click', () => navigate(links.home));
        }
      }
    };

    if (iframeRef.current) iframeRef.current.addEventListener('load', handleIframeLoad);

    return () => {
      if (iframeRef.current) iframeRef.current.removeEventListener('load', handleIframeLoad);
    };
  }, []);

  return <iframe ref={iframeRef} title="insert-management-approve" src={path} width="100%" height="700px" />;
}

export default InsertManagementApprove;
